export default {
  logs: {
    columnUserName: "User Name",
    columnStartDateTime: "Start Date Time",
    columnEndDateTime: "End Date Time",
    columnAction: "Action",
    columnComment: "Comment",
    textAreaObservation: "Detailed comment selected action",
    log: "Log",
    tittleDialog: "Work Flow Log",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/createNewMaterials/Stages/logs.js